/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListDismissedRiskResultsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListDismissedRiskResultsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListDismissedRiskResultsSecurity = {
  option1?: ListDismissedRiskResultsSecurityOption1 | undefined;
  option2?: ListDismissedRiskResultsSecurityOption2 | undefined;
};

export const Reasons = {
  Rule: "rule",
  Manual: "manual",
  Automated: "automated",
} as const;
export type Reasons = ClosedEnum<typeof Reasons>;

export type ListDismissedRiskResultsRequest = {
  /**
   * Cursor to fetch the next page of results.
   */
  cursor?: string | undefined;
  /**
   * Maximum number of results to return per page.
   */
  limit?: number | undefined;
  /**
   * Only return results suppressed for these reasons. Omitted or empty means all reasons.
   */
  reasons?: Array<Reasons> | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListDismissedRiskResultsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListDismissedRiskResultsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListDismissedRiskResultsSecurityOption1$Outbound,
    ListDismissedRiskResultsSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listDismissedRiskResultsSecurityOption1ToJSON(
  listDismissedRiskResultsSecurityOption1:
    ListDismissedRiskResultsSecurityOption1,
): string {
  return JSON.stringify(
    ListDismissedRiskResultsSecurityOption1$outboundSchema.parse(
      listDismissedRiskResultsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListDismissedRiskResultsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListDismissedRiskResultsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListDismissedRiskResultsSecurityOption2$Outbound,
    ListDismissedRiskResultsSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listDismissedRiskResultsSecurityOption2ToJSON(
  listDismissedRiskResultsSecurityOption2:
    ListDismissedRiskResultsSecurityOption2,
): string {
  return JSON.stringify(
    ListDismissedRiskResultsSecurityOption2$outboundSchema.parse(
      listDismissedRiskResultsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListDismissedRiskResultsSecurity$Outbound = {
  Option1?: ListDismissedRiskResultsSecurityOption1$Outbound | undefined;
  Option2?: ListDismissedRiskResultsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListDismissedRiskResultsSecurity$outboundSchema: z.ZodMiniType<
  ListDismissedRiskResultsSecurity$Outbound,
  ListDismissedRiskResultsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListDismissedRiskResultsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListDismissedRiskResultsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listDismissedRiskResultsSecurityToJSON(
  listDismissedRiskResultsSecurity: ListDismissedRiskResultsSecurity,
): string {
  return JSON.stringify(
    ListDismissedRiskResultsSecurity$outboundSchema.parse(
      listDismissedRiskResultsSecurity,
    ),
  );
}

/** @internal */
export const Reasons$outboundSchema: z.ZodMiniEnum<typeof Reasons> = z.enum(
  Reasons,
);

/** @internal */
export type ListDismissedRiskResultsRequest$Outbound = {
  cursor?: string | undefined;
  limit?: number | undefined;
  reasons?: Array<string> | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListDismissedRiskResultsRequest$outboundSchema: z.ZodMiniType<
  ListDismissedRiskResultsRequest$Outbound,
  ListDismissedRiskResultsRequest
> = z.pipe(
  z.object({
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    reasons: z.optional(z.array(Reasons$outboundSchema)),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listDismissedRiskResultsRequestToJSON(
  listDismissedRiskResultsRequest: ListDismissedRiskResultsRequest,
): string {
  return JSON.stringify(
    ListDismissedRiskResultsRequest$outboundSchema.parse(
      listDismissedRiskResultsRequest,
    ),
  );
}
